import React from 'react';
import { formValueSelector, reset } from 'redux-form';
import { connect } from 'react-redux';

import {
    CheckboxInputFieldComponent,
    EmailInputFieldComponent,
    LegendFieldComponent,
    NumberInputFieldComponent
} from '../../../../components/form';

import { sendPaymentRequest } from '../../../../services/account/paymentrequest/request/actions';

import { PAYMENT_THRESHOLD } from '../../../../constants';
import LocalizedNavLink from '../../../router/LocalizedNavLink';
import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';
import { getValidatedAmount } from '../../../../services/account/gains/selector';
import * as paymentRequestSelector from '../../../../services/account/paymentrequest/request/selector';

import { PaymentRequestStyledFormComponentContainer } from './PaymentRequestFormComponentStyle';

const FORM_NAME = 'paymentrequest-form';

class PaymentRequestFormComponent extends React.Component {
    componentDidMount() {
        this.scrollTop();
    }

    scrollTop = () => {
        if (document.getElementById('paymentAreaAnchor')) {
            document.getElementById('paymentAreaAnchor').scrollIntoView({ behavior: 'smooth' });
        }
    };

    submit = formData => {
        const { sendPaymentRequest, reset } = this.props;

        sendPaymentRequest(formData, () => {
            reset(FORM_NAME);
            this.scrollTop();
        });
    };

    render() {
        const {
            i18n,
            i18nCommon,
            errorSubmit,
            errorMessage,
            requestSubmit,
            initialValues,
            validatedCashbackAmount,
            remainingJackpotAfterPayment
        } = this.props;

        return (
            <PaymentRequestStyledFormComponentContainer
                form={FORM_NAME}
                initialValues={initialValues}
                classNameInputContainer="payment-request-form"
                onSubmit={this.submit}
                requestSubmit={requestSubmit}
                errorSubmit={errorSubmit}
                submitText={i18n.PAYMENT_REQUEST_FORM.PAYMENT_REQUEST_BUTTON}>
                <NumberInputFieldComponent
                    label={i18n.PAYMENT_REQUEST_FORM.PAYMENT_AMOUNT_INPUT_INDICATION}
                    placeholder={i18n.PAYMENT_REQUEST_FORM.PAYMENT_AMOUNT_PLACEHOLDER}
                    name="requestedAmount"
                    max={validatedCashbackAmount}
                    min={PAYMENT_THRESHOLD}
                    isRequired
                />

                <LegendFieldComponent>
                    {convertHtmlToReactDomWithParams(
                        i18n.PAYMENT_REQUEST_FORM.REMAINING_JACKPOT_AFTER_PAYMENT_INDICATION,
                        remainingJackpotAfterPayment.toFixed(2).replace('.', ',')
                    )}
                </LegendFieldComponent>

                <LegendFieldComponent classNameInputContainer="full">
                    {i18n.PAYMENT_REQUEST_FORM.OFFER_CONDITIONS_INDICATION}
                    <LocalizedNavLink to={i18n.PAYMENT_REQUEST_FORM.OFFER_CONDITIONS_URL}>
                        {i18n.PAYMENT_REQUEST_FORM.OFFER_CONDITIONS_URL}
                    </LocalizedNavLink>
                </LegendFieldComponent>

                <EmailInputFieldComponent
                    label={i18n.PAYMENT_REQUEST_FORM.EMAIL_ADDRESS_CONFIRMATION}
                    placeholder={i18nCommon.PLACEHOLDER_EMAIL}
                    name="email"
                    isRequired
                />

                <LegendFieldComponent classNameInputContainer="full">
                    {i18nCommon.MANDATORY_FIELD}
                </LegendFieldComponent>

                <CheckboxInputFieldComponent
                    name="confirmEmail"
                    options={[
                        {
                            label:
                                i18n.PAYMENT_REQUEST_FORM.EMAIL_DELIVERY_VALIDATION_CHECKBOX_LABEL,
                            value: true
                        }
                    ]}
                    minRequired={1}
                />

                {errorMessage && (
                    <LegendFieldComponent classNameInputContainer="color-err">
                        {errorMessage}
                    </LegendFieldComponent>
                )}
            </PaymentRequestStyledFormComponentContainer>
        );
    }
}

const mapDispatchToProps = {
    sendPaymentRequest,
    reset
};

const mapStoreToProps = state => {
    const validatedCashbackAmount = getValidatedAmount(state);

    return {
        requestSubmit: paymentRequestSelector.isRequesting(state),
        errorSubmit: paymentRequestSelector.isError(state),
        errorMessage: paymentRequestSelector.getError(state),
        successSubmit: paymentRequestSelector.isSuccess(state),
        i18n: state.i18n.page.ACCOUNT.CASHBACK_JACKPOT,
        i18nCommon: state.i18n.feature.form,
        validatedCashbackAmount: validatedCashbackAmount,
        initialValues: {
            requestedAmount: '',
            email: ''
        },
        remainingJackpotAfterPayment:
            validatedCashbackAmount - formValueSelector(FORM_NAME)(state, 'requestedAmount')
    };
};

export default connect(mapStoreToProps, mapDispatchToProps)(PaymentRequestFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/cashback/PaymentRequestFormComponent.js